export enum UserRights {
  CAMPAIGNS_READ = 'TuRRecourseCockpit.Campaigns.Read',
  CAMPAIGNS_APPROVE = 'TuRRecourseCockpit.Campaigns.Approve',
  CAMPAIGNS_WORKFLOW = 'TuRRecourseCockpit.Campaigns.Workflow',
  CAMPAIGNS_BOOKING = 'TuRRecourseCockpit.Campaigns.Booking',

  RECOURSE_READ = 'TuRRecourseCockpit.GuKRecourse.Read',
  RECOURSE_APPROVE = 'TuRRecourseCockpit.GuKRecourse.Approve',
  RECOURSE_BOOKING = 'TuRRecourseCockpit.GuKRecourse.Booking',

  RAD_READ = 'TuRRecourseCockpit.RaDRecourse.Read',
  RAD_APPROVE = 'TuRRecourseCockpit.RaDRecourse.Approve',
  RAD_BOOKING = 'TuRRecourseCockpit.RaDRecourse.Booking',

  AFTERSALES_APPROVE = 'TuRRecourseCockpit.Aftersales.Approve',
  AFTERSALES_BOOKING = 'TuRRecourseCockpit.Aftersales.Booking',
  AFTERSALES_EDIT = 'TuRRecourseCockpit.Aftersales.EditCosts',
  AFTERSALES_READ = 'TuRRecourseCockpit.Aftersales.Read',
  AFTERSALES_SUPPLIER_AND_RATES = 'TuRRecourseCockpit.Aftersales.SuppliersAndRates',

  QPP_SYS_RESERVE = 'QPP.SetSystematicRequest',
}
